const enviroments = {
    prd: 'https://hscappssp01.hospitalsaocamilosp.org.br:6010/convenios',
    dev: 'http://172.17.1.252:6009/convenios',
    token: 'f353256c789ef7b149077fd9640cea75'
}

export default enviroments;